module.exports = __webpack_public_path__ + "img/corrupted_treant_small.413e0c3a.png";